import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../utils/createNotification';
import { ServiceFocus } from '../models/service-focus';

export const AddServiceFocus = createAsyncThunk(
    'serviceFocuses/add',
    async (newFocus: ServiceFocus, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.post('/api/ServiceFocuses', newFocus);

            if (response.status !== 200) {
                createNotification('Could not add service focus.', 'error');
                throw new Error('Failed to add service focus');
            }

            createNotification('Service focus added successfully.', 'success');
            return response.data as ServiceFocus;
        } catch (error) {
            createNotification(
                'An error occurred while adding service focus.',
                'error'
            );
            throw error;
        }
    }
);
